import { EMPTY_LIST } from '../../../../constants/common'
import { FileList } from '../../../File'
import { ScrollSlider } from '../../../ScrollSlider'
import {
  useDocFlowContext,
  useDocFlowMappingContext,
} from '../../DocFlow.hooks'
import {
  isDocFlowWidgetStatusCompleted,
  isDocFlowWidgetStatusInProgress,
} from '../../DocFlow.utils.widgets'
import { DocFlowFile } from '../../DocFlowFile'
import { isDocFlowMappingIsFileAwsProcess } from '../DocFlowMapping.utils'

import {
  DOC_FLOW_MAPPING_FILE_LIST_SLIDER_ITEM_GAP,
  DOC_FLOW_MAPPING_FILE_LIST_SLIDER_ITEM_WIDTH,
} from './DocFlowMappingFileListSlider.constants'

import * as styles from './DocFlowMappingFileListSlider.module.css'

function DocFlowMappingFileListSlider({ onChangeActiveFile }) {
  const { files, isFileListInitiated, processData, someFileInProgress } =
    useDocFlowMappingContext()

  const { mappingPhaseFileActive } = useDocFlowContext()

  const isLoading = !isFileListInitiated || !mappingPhaseFileActive

  function renderFile(file, key) {
    return (
      <DocFlowFile
        disabled={
          someFileInProgress && !isDocFlowWidgetStatusInProgress(file.status)
        }
        done={isDocFlowWidgetStatusCompleted(file.status)}
        file={file}
        isActive={mappingPhaseFileActive === file.id}
        isSkeleton={isLoading}
        key={key}
        mappingPhaseFileActive={mappingPhaseFileActive}
        process={isDocFlowMappingIsFileAwsProcess(
          processData,
          mappingPhaseFileActive === file.id
        )}
        onSelectFile={onChangeActiveFile}
      />
    )
  }

  return (
    <ScrollSlider
      isLoading={isLoading}
      itemGap={DOC_FLOW_MAPPING_FILE_LIST_SLIDER_ITEM_GAP}
      itemWidth={DOC_FLOW_MAPPING_FILE_LIST_SLIDER_ITEM_WIDTH}
    >
      <FileList
        className={styles.list}
        files={files || EMPTY_LIST}
        isSkeleton={isLoading}
        itemClassName={styles.item}
        renderItem={renderFile}
      />
    </ScrollSlider>
  )
}

export default DocFlowMappingFileListSlider
